import { createFileRoute } from "@tanstack/react-router";
import { ProductPage } from "@/components/site/ProductPage";
import { getProduct } from "@/data/products";
import { getProductHero } from "@/data/productHeroes";
import { buildHead } from "@/lib/seo-head";

const SLUG = "bridge-loans";
const PRODUCT = getProduct(SLUG)!;
const HERO = getProductHero(SLUG);
const URL = `/${SLUG}`;

const KEYWORDS = [
  "bridge loan",
  "real estate bridge loan",
  "bridge loan for investors",
  "short term bridge financing",
  "bridge to DSCR loan",
  "bridge loan rates",
  "acquisition bridge loan",
  "reposition bridge financing",
  "bridge loan LLC",
  "interest only bridge loan",
  "bridge loan for rental property",
  "fast closing bridge loan",
].join(", ");

export const Route = createFileRoute("/bridge-loans/")({
  head: () =>
    buildHead({
      title: "Bridge Loans for Real Estate Investors",
      description:
        "Short-term bridge loans to acquire, reposition, or season a property before refinancing into long-term DSCR debt. Fast closings, LLC-friendly.",
      url: URL,
      keywords: KEYWORDS,
      image: HERO?.src,
      imageAlt: HERO?.alt,
      breadcrumbs: [
        { name: "Home", url: "/" },
        { name: PRODUCT.shortName, url: URL },
      ],
      service: { name: PRODUCT.name },
      faqs: PRODUCT.faq.map((f) => ({ q: f.q, a: f.a })),
    }),

  component: () => (
    <ProductPage
      product={PRODUCT}
    />
  ),
});
